import { useEffect, useState, useMemo } from "react"; // Import useMemo
import APIConfig from "../../../../APIConfig";
import { useFetchWithAuth } from "../../../../data layer/useFetchWithAuth";

const useProfileInfo = () => {
  const profileUrl = `${APIConfig.me()}`;
  console.log("profileUrl: ", profileUrl);
  const {
    data: profileInfo,
    loading,
    error,
  } = useFetchWithAuth(profileUrl, {
    method: "GET",
  });

  // useMemo to compute artists based on profileInfo
  const artists = useMemo(() => {
    console.log("Computing artists from profileInfo");
    if (!profileInfo || !profileInfo.artists) {
      return [];
    }
    return profileInfo.artists;
  }, [profileInfo]);

  return { profileInfo, artists, loading, error };
};

export default useProfileInfo;
